Drupal.behaviors.accessibilityButtons = {
    attach: function (context, settings) {

        function backToTop(accessibilityButton, scrollTrigger) {
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            if (scrollTop > scrollTrigger) {
                accessibilityButton.classList.add('show');
            } else {
                accessibilityButton.classList.remove('show');
            }
        }

        const accessibilityButton = once(
            "onceAccessibilityButtons",
            document.getElementById("back-to-top-button")
        )[0];
        if (accessibilityButton) {
            var scrollTrigger = 300;
            backToTop(accessibilityButton, scrollTrigger);

            window.addEventListener('scroll', function () {
                backToTop(accessibilityButton, scrollTrigger);
            });

            accessibilityButton.addEventListener('click', function (e) {
                e.preventDefault();
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            });
        }
    },
};
